export default "__VITE_ASSET__DTo6wsKu__"